import { useAtomValue } from 'jotai';

import { selectedImageAtom } from '@/features/image-rendering/atoms/imageFiles';
import { settingsChangedAtom, settingsFilledAtom } from '@/features/image-rendering/atoms/settings';
import {
  renderingsEstateIdAtom,
  renderingsProjectIdAtom,
} from '@/features/renderings/shared/atoms/relation';

export const useAiRenderingCanGenerate = () => {
  const isSettingsFilled = useAtomValue(settingsFilledAtom);
  const didSettingsChange = useAtomValue(settingsChangedAtom);
  const selectedImage = useAtomValue(selectedImageAtom);
  const estateId = useAtomValue(renderingsEstateIdAtom);
  const projectId = useAtomValue(renderingsProjectIdAtom);

  const hasSourceImage = Boolean(
    selectedImage?.file || selectedImage?.originalImageId || selectedImage?.originalImage
  );

  return (
    hasSourceImage &&
    (didSettingsChange || !selectedImage?.renderedImage) &&
    isSettingsFilled &&
    (Boolean(estateId) || Boolean(projectId))
  );
};
